// Modules
import React from "react";

// Styles
import "./MvLoader.sass";

type Props={
  show:boolean;
  children: React.ReactNode;
  loadingMessage?: string;
}
class MvLoader extends React.Component<Props, {}> {
  render() {
    let loader = (
      <div className="loader">
        <div className="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
    // let content = this.props.show ? loader : this.props.children;
    return (
      <div className="loader-wrapper">
        {this.props.show && this.props.loadingMessage && <div className='loader-message'>{this.props.loadingMessage}</div>}
        <div className={"loader " + (!this.props.show ? "hide" : "")}>
          <div className="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}
export default MvLoader;
